const globalVars = {
    version: "0.1.0",
    contentType: "",
    slug: "",
    plz: "",
    plzDialog: 'plzDialog'
}

// Tabbed Menu
let openMenu = function (evt: Event, menuName: string, contentType: string = '', slug: string = '') {

    globalVars.contentType = contentType;
    globalVars.slug = slug;

    if(globalVars.plzDialog === menuName && globalVars.plz != "") {
        openMenu(event, 'details-' + globalVars.contentType + '-' + globalVars.slug);
        return;
    }
    let i:number, menuElement:HTMLCollectionOf<Element>, tabLinks: HTMLCollectionOf<Element>;
    menuElement = document.getElementsByClassName("menu");
    for (i = 0; i < menuElement.length; i++) {
        // @ts-ignore
        menuElement[i].style.display = "none";
    }
    tabLinks = document.getElementsByClassName("tabLink");
    for (i = 0; i < menuElement.length; i++) {
        if (tabLinks[i]) {
            // @ts-ignore
            tabLinks[i].className = tabLinks[i].className.replace(" w3-red", "");
        }

    }
    if (menuName.startsWith('details-')) {
        const imageElement = <HTMLImageElement>document.getElementById(menuName+'-img');
        imageElement.src = imageElement.dataset.src;
    }
    document.getElementById(menuName).style.display = "block";

    // @ts-ignore
    if (evt.currentTarget.firstElementChild) {
        // @ts-ignore
        evt.currentTarget.firstElementChild.className += " w3-red";
    }
    // evt.currentTarget.firstElementChild.className += " w3-red";
}

window.addEventListener("load", (event) => {
    document.body.querySelectorAll(".entry .w3-container").forEach(function(node,i){
        // node.classList.add(i % 2?"w3-blue-grey":"w3-red");
        if(document.body.querySelectorAll(".entry .w3-container").length != i-1) {
            node.classList.replace("w3-black", i % 2?"w3-blue-grey":"w3-red");
        }
    })
});


